import { useState } from 'react';
import styles from './AddProductInCartButton.module.css';

export const AddProductInCartButton = ({ 
    addProductInCart, 
    id}) => {
        const action = () => {
            addProductInCart(id)
        }

    return (
        <button className={styles.button}
            onClick={() => action()}>
            У кошик
        </button>
    )
}